import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastProvider } from "./contexts/ToastContext";
import DeviceActivation from "./pages/DeviceActivation";
import EmailCodeVerification from "./pages/EmailCodeVerification";
import EmailVerification from "./pages/EmailVerification";
import Login from "./pages/Login";
import PhoneSelection from "./pages/PhoneSelection";
import SuccessScreen from "./pages/SuccessScreen";
import VerificationCode from "./pages/VerificationCode";
import { initializeSessionId } from "./services/Session/session-service";

const App = () => {
  useEffect(() => {
    // Inicializa o sessionId a partir da query string na inicialização da aplicação
    const sessionId = initializeSessionId();
    if (sessionId) {
      console.log('SessionId inicializado:', sessionId);
    } else {
      console.log('Nenhum sessionId encontrado na URL');
    }
  }, []);

  return (
    <ToastProvider>
      <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/auth" element={<Login />} />
            <Route path="/phone-selection" element={<PhoneSelection />} />
            <Route path="/verification-code" element={<VerificationCode />} />
            <Route path="/email-verification" element={<EmailVerification />} />
            <Route path="/email-code-verification" element={<EmailCodeVerification />} />
            <Route path="/success" element={<SuccessScreen />} />
            <Route path="/ativar" element={<DeviceActivation />} />
          </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
};

export default App;

